import { E_Network } from '@/ts/enums/E_Network';

const alchemyApiKey =
  process.env.NEXT_PUBLIC_ALCHEMY_API_KEY ||
  process.env.ALCHEMY_API_KEY ||
  'M-3qv9vzYr6XSJVYl6rBu';

if (!alchemyApiKey) {
  throw new Error('Alchemy API key is not configured');
}

export const C_NETWORK_RPC_URLS: Record<E_Network, string> = {
  [E_Network.SEPOLIA]: `https://eth-sepolia.g.alchemy.com/v2/${alchemyApiKey}`,
  [E_Network.BASE]: `https://base-mainnet.g.alchemy.com/v2/${alchemyApiKey}`,
  [E_Network.BASE_SEPOLIA]: `https://base-sepolia.g.alchemy.com/v2/${alchemyApiKey}`
};
